module.exports = __webpack_public_path__ + "img/_54A6777.e0d8758b.jpg";